import { render } from "./tableCluster.vue?vue&type=template&id=0025bef8&scoped=true"
import script from "./tableCluster.vue?vue&type=script&lang=js"
export * from "./tableCluster.vue?vue&type=script&lang=js"

import "./tableCluster.vue?vue&type=style&index=0&id=0025bef8&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0025bef8"]])

export default __exports__